import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Grid, Form } from 'semantic-ui-react';
import React, { Component, Fragment } from 'react';
import { Field, reduxForm, getFormValues, change } from 'redux-form';

import { TitledCard } from 'Components';
import { SiteComponent } from 'Common/SiteComponent';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { DatePickerField } from 'Common/SemanticWrapper';
import { CHECKS_SUMMARY_REPORT_FORM_NAME } from 'Common/FormEnum';
import { ChecksSummaryReportFieldEnum as Fields } from 'Common/FieldEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';

class ChecksSummaryReportFormContainer extends Component {
  ReportTypeOptions = [
    { label: 'Transaction History', value: 'TransactionHistory' },
    { label: 'Checks for Deposit', value: 'ChecksForDeposit' },
  ];

  MealTypeOptions = [
    { label: 'Breakfast/Lunch/Snack', value: false },
    { label: 'Supper', value: true },
  ];

  SortByOptions = [
    { label: 'Student #', value: 'StudentNumber' },
    { label: 'Time', value: 'Time' },
  ];

  componentDidUpdate(prevProps, prevState) {
    const { formValues } = this.props;
    if (
      formValues[Fields.SiteGroup] !== prevProps.formValues[Fields.SiteGroup]
    ) {
      this.setState({ filterSites: this.filterSites() });
    }
  }

  handleChange = value => {
    this.setState({ selectedReportType: value });
  };

  handleSiteChange = value => {
    this.props.dispatch(
      change(CHECKS_SUMMARY_REPORT_FORM_NAME, Fields.SiteId, value)
    );
  };

  render() {
    const { formValues, loading } = this.props;
    const transactionHistorySelected =
      this.state === null ||
      this.state.selectedReportType === 'TransactionHistory';

    return (
      <Fragment>
        <Form name={CHECKS_SUMMARY_REPORT_FORM_NAME}>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <TitledCard title="Report Settings">
                  <Grid>
                    <Grid.Row>
                      <Grid.Column className="input-group--btn-group">
                        <ReduxFormButtonGroup
                          label={'Report Type'}
                          options={this.ReportTypeOptions}
                          formName={CHECKS_SUMMARY_REPORT_FORM_NAME}
                          value={formValues[Fields.ReportType]}
                          fieldName={Fields.ReportType}
                          loading={loading}
                          disabled={loading}
                          onChange={this.handleChange}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column className="input-group--btn-group">
                        <ReduxFormButtonGroup
                          label={'Meal Type'}
                          options={this.MealTypeOptions}
                          formName={CHECKS_SUMMARY_REPORT_FORM_NAME}
                          value={formValues[Fields.IsSupper]}
                          fieldName={Fields.IsSupper}
                          loading={loading}
                          disabled={loading}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={8}>
                        <SiteComponent
                          name={Fields.SiteId}
                          isForm={true}
                          isPrimary={true}
                          selectFirst={transactionHistorySelected}
                          isAllRequired={transactionHistorySelected}
                          disabled={loading}
                          onChange={this.handleSiteChange}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={10}>
                        <Field
                          label={
                            transactionHistorySelected ? 'From Date' : 'Date'
                          }
                          name={Fields.FromDate}
                          component={DatePickerField}
                          type="text"
                          openToDate={moment()}
                          disabled={loading}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      {transactionHistorySelected && (
                        <Grid.Column width={10}>
                          <Field
                            label={'To Date'}
                            name={Fields.ToDate}
                            component={DatePickerField}
                            type="text"
                            openToDate={moment()}
                            disabled={loading}
                          />
                        </Grid.Column>
                      )}
                    </Grid.Row>
                  </Grid>
                  {transactionHistorySelected && (
                    <Grid>
                      <Grid.Row>
                        <Grid.Column className="input-group--btn-group">
                          <ReduxFormButtonGroup
                            label={'Sort By'}
                            options={this.SortByOptions}
                            formName={CHECKS_SUMMARY_REPORT_FORM_NAME}
                            value={formValues[Fields.SortBy]}
                            fieldName={Fields.SortBy}
                            disabled={loading}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  )}
                </TitledCard>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};

  if (
    (values[Fields.SiteId] === 'ALL' &&
      values[Fields.ReportType] === 'ChecksForDeposit') ||
    !values[Fields.SiteId]
  ) {
    errors[Fields.SiteId] = 'Site must be set.';
  }

  if (!moment(values[Fields.FromDate]).isValid()) {
    errors[Fields.FromDate] = 'Enter a valid From Date.';
  }
  if (!values[Fields.FromDate]) {
    errors[Fields.FromDate] = 'From Date must be set.';
  }

  if (!moment(values[Fields.ToDate]).isValid()) {
    errors[Fields.ToDate] = 'Enter a valid To Date.';
  }
  if (!values[Fields.ToDate]) {
    errors[Fields.ToDate] = 'To Date must be set.';
  }
  if (
    moment(values[Fields.ToDate], DATE_FORMAT_FOR_UI).isBefore(
      moment(values[Fields.FromDate], DATE_FORMAT_FOR_UI)
    )
  ) {
    errors[Fields.ToDate] =
      'To Date must be greater than or equal to From Date.';
    errors[Fields.FromDate] =
      'To Date must be greater than or equal to From Date.';
  }

  return errors;
};

const mapStateToProps = state => {
  return {
    formValues: getFormValues(CHECKS_SUMMARY_REPORT_FORM_NAME)(state),
    loading: state.ChecksSummaryReportState.checksSummaryReport.loading,
  };
};

const ChecksSummaryReportForm = reduxForm({
  form: CHECKS_SUMMARY_REPORT_FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(withRouter(connect(mapStateToProps)(ChecksSummaryReportFormContainer)));

export { ChecksSummaryReportForm };



// WEBPACK FOOTER //
// ./src/pages/checkssummaryreport/components/ChecksSummaryReportForm.js